<template>
    <div>
        <!-- 顶部显示 -->
        <el-breadcrumb
            separator-class="el-icon-arrow-right"
            style="margin-bottom: 10px"
        >
            <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 新增按钮 -->
        <div style="margin: 15px 0">
            <el-input
                placeholder="请输入用户昵称进行搜索"
                clearable
                v-model="nickName"
                style="width: 240px"
                @input="searchInput"
            ></el-input>
            <el-input
                placeholder="请输入手机号进行搜索"
                clearable
                v-model="wxPhone"
                style="width: 240px"
                @input="searchInput"
            ></el-input>
            <!-- <el-select v-model="isAgent" placeholder="请选择用户身份" filterable>
                <el-option
                label="代理商"
                :value="1"/>
                <el-option
                label="普通用户"
                :value="0"/>
            </el-select> -->
        </div>
        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="nick_name_origin" align="center" min-width="120" label="用户昵称">
            </el-table-column>
            <el-table-column prop="wx_phone" align="center" width="150" label="手机号码">
            </el-table-column>
            <el-table-column label="用户身份" align="center" width="100">
                <template slot-scope="scope">{{scope.row.is_agent == 1 ? '代理商' : '普通用户'}}</template>
            </el-table-column>
            <el-table-column align="center" label="注册时间" width="180" prop="create_time" />
            <el-table-column label="操作" align="center" width="350">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleSetAgent(scope.row)"
                        >代理商设置</el-button
                    >
                    <el-button v-if="scope.row.is_agent == 1" size="mini" @click="handleAgentSet(scope.row)"
                        >代理商景区设置</el-button
                    >
                    <el-button
                        v-if="scope.row.is_agent == 1"
                        size="mini"
                        type="danger"
                        @click="handleAgentCancel(scope.row)"
                        >取消代理商</el-button
                    >
                </template>
            </el-table-column>
        </el-table>
        <!-- 修改按钮的弹框 -->
        <el-dialog
            title="代理商设置"
            :visible.sync="editdialogVisible"
            :rules="rules"
            width="30%"
        >
            <el-form :model="editInfo" ref="agentForm" label-width="130px">
                <el-form-item label="代理商姓名" prop="agent_name">
                    <el-input v-model="editInfo.agent_name"/>
                </el-form-item>
                <el-form-item label="分成比例" prop="proportion">
                    <el-input v-model="editInfo.proportion">
                        <template slot="append">%</template>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="submitFormedit"
                        >保存</el-button
                    >
                    <el-button @click="editdialogVisible = false"
                        >取消</el-button
                    >
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog
            title="代理商景区设置"
            :visible.sync="scenicdialogVisible"
            :rules="rules"
            width="50%"
        >
            <el-form :model="scenicForm" ref="scenicForm" label-width="130px">
                <el-form-item label="景区分成设置" prop="areaAgents">
                    <el-button
                        type="primary"
                        @click="addProportion"
                    >添加</el-button>
                    <el-table
                        :data="scenicForm.areaAgents"
                        style="width: 100%"
                    >
                        <el-table-column label="景区">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.area_id" filterable>
                                    <el-option
                                    v-for="item in scenicSpotList"
                                    :key="'scenic' + item.area_id"
                                    :label="item.area_name"
                                    :value="item.area_id"/>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="分成比例">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.proportion">
                                    <template slot="append">%</template>
                                </el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button
                                size="mini"
                                type="danger"
                                @click="deleteProportion(scope.$index)"
                                >删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="saveScenicSet"
                        >保存</el-button
                    >
                    <el-button @click="scenicdialogVisible = false"
                        >取消</el-button
                    >
                </el-form-item>
            </el-form>
        </el-dialog>
        <!-- 分页 -->
        <div>
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="pageSize"
                layout="total,  prev, pager, next, jumper"
                :total="total"
                style="
                    text-align: right;
                    margin: 0 16px 10px 0;
                    border-radius: 20px;
                "
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
import qs from "qs";
let inputTimer;
export default {
    name: 'MemberList',
    data() {
        return {
            nickName: '',
            wxPhone: '',
            isAgent: '',
            // 修改按钮的弹框与否
            editdialogVisible: false,
            // 修改弹框的表单
            editInfo: {
                agent_name: '',
                status: 1,
                proportion: '',
            },
            scenicdialogVisible: false,
            scenicForm: {
                agent_id: '',
                areaAgents: [],
            },
            // 表单验证
            rules: {
                proportion: [
                    {
                        required: true,
                        message: "请输入分成比例",
                        trigger: "blur",
                    },
                ],
                areaAgents: [
                    { required: true, message: "请配置景区分成设置", trigger: "blur" },
                ],
            },
            tableData: [],
            currentPage: 1, //分页
            pageSize: 10,
            total: 0, //分页
            scenicSpotList: [], //获取景区的数组
            ids: [],
            genderDic: ["未知", "男", "女"],
        };
    },
    methods: {
        searchInput() {
            if (inputTimer) {
                clearTimeout(inputTimer);
            }
            inputTimer = setTimeout(() => {
                this.pageindex = 1;
                this.getList();
            }, 500);
        },
        // 重置按钮
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        // 景区的单选
        radioList(row) {
            var ids = "";
            ids = row;
            console.log(ids, 66666);
            this.ids = ids;
        },
        // 获取景区列表
        findScenicSpotList() {
            const salesInfoData = {
                pageindex: 1,
                pagesize: 9999,
            };
            const salesInfoParams = {
                methodUrl: "/admin/getScenicArea",
                jsonParam: qs.stringify(salesInfoData),
            };
            this.$axios.postRequest(salesInfoParams).then(
                res => {
                    //成功之后处理逻辑
                    this.scenicSpotList = res.data.list
                },
                err => {
                    //失败之后处理逻辑
                    console.log(err)
                }
            );
        },
        // 查询用户列表
        getList() {
            const salesInfoData = {
                nick_name_origin: this.nickName,
                wx_phone: this.wxPhone,
                isAgent: this.isAgent,
                count: true,
                pageindex: this.currentPage,
                pagesize: this.pageSize,
            };
            const salesInfoParams = {
                methodUrl: "/admin/getWechatUser",
                jsonParam: qs.stringify(salesInfoData),
            };
            this.$axios.postRequest(salesInfoParams).then(
                res => {
                    //成功之后处理逻辑
                    this.tableData = res.data.list;
                    this.total = res.data.totalcount;
                },
                err => {
                    //失败之后处理逻辑
                    console.log(err);
                }
            );
        },
        handleSetAgent(row) {
            this.editdialogVisible = true
            this.editInfo = {
                user_id: row.user_serial,
            }
            this.getAgentInfo(row.user_serial).then(res => {
                this.editInfo = {
                    ...res,
                    is_agent: 1,
                }
            }).catch(err => {
                console.log(err)
            })
        },
        getAgentInfo(id){
            return new Promise((resolve, reject) => {
                const salesInfoParams = {
                    methodUrl: "/admin/getAgentRecord",
                    jsonParam: qs.stringify({
                        user_id: id,
                    }),
                }
                this.$axios.postRequest(salesInfoParams).then(
                    res => {
                        if(res.data.list.length > 0){
                            resolve(res.data.list[0])
                        }else{
                            reject(res)
                        }
                    },
                    err => {
                        //失败之后处理逻辑
                        reject(err)
                    }
                )
            })
        },
        // 点击修改按钮发送修改请求
        submitFormedit() {
            this.$refs.agentForm.validate((valid) => {
                if (valid) {
                    this.editdialogVisible = false
                    const salesInfoParams = {
                        methodUrl: this.editInfo.is_agent == 1 ? '/admin/upAgentRecord' : '/admin/addAgentRecord',
                        jsonParam: qs.stringify(this.editInfo),
                    };
                    this.$axios.postRequest(salesInfoParams).then(
                        res => {
                            this.getList()
                        },
                        err => {
                            //失败之后处理逻辑
                            console.log(err);
                        }
                    )
                } else {
                    console.log("error submit!!");
                    return false;
                }
            })
        },
        handleAgentSet(row) {
            this.scenicdialogVisible = true;
            this.scenicForm = {
                agent_id: '',
                areaAgents: [],
            }
            this.getAgentInfo(row.user_serial).then(res => {
                this.scenicForm.agent_id = res.id
                const salesInfoParams = {
                    methodUrl: "/admin/getAreaAgent",
                    jsonParam: qs.stringify({
                        agent_id: res.id,
                    }),
                }
                this.$axios.postRequest(salesInfoParams).then(
                    res => {
                        this.scenicForm.areaAgents = res.data
                    },
                    err => {
                        //失败之后处理逻辑
                        console.log(err)
                    }
                )
            })
        },
        addProportion(){
            this.scenicForm.areaAgents.push({
                area_id: '',
                proportion: '',
            })
        },
        deleteProportion(index){
            this.scenicForm.areaAgents.splice(index, 1)
        },
        saveScenicSet(){
            this.$refs.scenicForm.validate((valid) => {
                if (valid) {
                    this.scenicdialogVisible = false
                    const salesInfoParams = {
                        methodUrl: '/admin/addAreaAgent',
                        jsonParam: qs.stringify(this.scenicForm),
                    };
                    this.$axios.postRequest(salesInfoParams).then(
                        res => {
                            this.$message({
                                showClose: true,
                                message: "设置成功",
                                type: "success"
                            })
                        },
                        err => {
                            //失败之后处理逻辑
                            console.log(err);
                        }
                    )
                } else {
                    console.log("error submit!!");
                    return false;
                }
            })
        },
        handleAgentCancel(row) {
            this.$confirm("您确定要取消用户代理商身份吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.getAgentInfo(row.user_serial).then(res => {
                    const salesInfoParams = {
                        methodUrl: "/admin/delAgentRecord",
                        jsonParam: qs.stringify({
                            id: res.id,
                        }),
                    }
                    this.$axios.postRequest(salesInfoParams).then(
                        res => {
                            //成功之后处理逻辑
                            row.is_agent = 0
                        },
                        err => {
                            //失败之后处理逻辑
                            console.log(err);
                        }
                    )
                })
            })
        },
        // 分页
        handleSizeChange(val) {
            this.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getList();
        },
    },
    mounted() {
        this.getList();
        this.findScenicSpotList()
    },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/memberList.vue